import React from 'react';
import LzMCrud from '@lz/models/crud/Crud';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

const config = new LzMCrud({
    ident: 'roles',
    baseRoute: '/system/roles',
    fields: {
        name: { size: 100, type: 'string', required: true },
    },
    listingColumns: {
        name: { label: 'Role Name', sortable: true, alignment: 'left' },
    },
    listingActionIcons: {
        rights: {
            route: '/system/roles/{recordId}/rights',
            title: 'Rights',
            icon: <PlaylistAddCheckIcon />,
            color: 'info',
            sortOrder: 21,
        },
    },
    addFormInputs: {
        name: { label: 'Role Name' },
    },
    viewFormFields: {
        name: { label: 'Role Name' },
    },
    editFormInputs: {
        name: { label: 'Role Name' },
    },
    showDeletedList: false,
    allowDeletedRestore: false,
    allowDeletedPurge: false,
});

export default config;
